import { ContestantImport } from '@/objects/generated';

export class ContestantImportExtended {
    public ContestantImport: ContestantImport;
    public Name: string | null = null;

    public LastModified: string | null = null;

    public ColumnMap: any = {};

    public GenderMale: string | null = null;

    public GenderFemale: string | null = null;

    public GenderNeutral: string | null = null;

    public DateFormat: string | null = null;

    public TimeFormat: string | null = null;

    public KnownFilenames: string[] = [];

    public HasHeader: boolean = false;

    constructor(ci: ContestantImport, name: string, lastmodified: Date, columnmap: Map<string, string>) {
        this.ContestantImport = ci;

        // We make sure these are always empty
        this.ContestantImport.Rows = [];
        this.ContestantImport.Cols = [];

        this.Name = name;
        this.LastModified = lastmodified.toISOString();

        // Convert the map to a key value pair for serialization
        // Maps cant be serialized to JSON
        // TODO: Create a serialized Map class that can be serialized to JSON (need the toJSON method)
        columnmap.forEach((value, key) => {
            this.ColumnMap[key] = value;
        });
    }

    /**
     * Get the column map as a Map
     */
    public ColumnMapAsMap = (): Map<string, string> => {
        const map = new Map<string, string>();
        for (const key in this.ColumnMap) {
            map.set(key, this.ColumnMap[key]);
        }

        return map;
    };
}
